// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Subscriptions_EventRow.php
// Do not edit by hand — edit the PHP RowContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Subscriptions_EventRow — one row for the subscription_events timeline.
 *
 * Returned by findBySubscriptionId() / findByFranchiseId() after the
 * controller converts GMT-3 datetime fields to ISO-8601 UTC via date_api.
 *
 * Fields:
 *   id              — primary key
 *   provider        — 'gatewaytest' | 'asaas' | 'stripe' | 'audit'
 *   subscription_id — FK to franchises_subscriptions (nullable for audit events
 *                     that pre-date a subscription row)
 *   event_type      — e.g. 'SUBSCRIPTION_CREATED', 'PAYMENT_CONFIRMED',
 *                     'PAYMENT_OVERDUE', 'SWEEP_BLOCKED', 'GRACE_EXTENDED'
 *   status          — 'pending' | 'processed' | 'failed' | 'dead' (S4-04:
 *                     dead-lettered after MAX_REPROCESS_ATTEMPTS failed
 *                     replay attempts — Subscription_events_model.php)
 *   payload         — JSON string of the normalized event payload (nullable)
 *   error           — error_message from the DB column (nullable)
 *   processed_at    — ISO-8601 UTC datetime when the event was processed (nullable)
 *   created_at      — ISO-8601 UTC datetime when the event was stored
 */
import { registerContract } from './validate'

export interface Subscriptions_EventRow {
id: number
provider?: string
subscription_id?: number
event_type?: string
event_id?: string
status?: string
payload?: string
error?: string
processed_at?: string
created_at?: string
}

registerContract('Subscriptions_EventRow', {
  id:              { type: 'number',  required: true },
  provider:        { type: 'string',  required: false },
  subscription_id: { type: 'number',  required: false },
  event_type:      { type: 'string',  required: false },
  event_id:        { type: 'string',  required: false },
  status:          { type: 'string',  required: false },
  payload:         { type: 'string',  required: false },
  error:           { type: 'string',  required: false },
  processed_at:    { type: 'string',  required: false },
  created_at:      { type: 'string',  required: false },
})
